import React, { useEffect } from 'react';
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import { CURRENT_LOCALE } from '@whitelabel/helpers/constants';
import { IUser } from './types';

/**
 *  handles restricting FNOL without Auth to selected partners
 *  */
export function useSecureFNOL(user: IUser, securityToken: string | null, locale: string): void {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (user) return;
    if (!securityToken) {
      history.push({
        pathname: `/${locale}/login`,
        state: { referrer: location },
      });
    }
  }, [history, locale, location, securityToken, user]);
}

export const getClaimURLQueryParams = (search: any) => {
  const urlParams = new URLSearchParams(search);
  const bookingID = urlParams.get('bookingID');
  const claimSelectorID = urlParams.get('claimSelectorID');
  const currentDecisionPointId = urlParams.get('currentDecisionPointId');
  const quoteID = urlParams.get('quoteID');
  const securityToken = urlParams.get('security_token');
  const claimTypeID = urlParams.get('claimTypeID');
  const claimID = urlParams.get('claimID');
  const hasClaimGuidelines = urlParams.get('claimGuidelines') === 'true';

  return {
    bookingID,
    quoteID,
    claimSelectorID,
    currentDecisionPointId,
    securityToken,
    claimTypeID,
    claimID,
    hasClaimGuidelines,
  };
};

interface INavigateToClaimQuestionsPageArgs {
  decisionPointId: string;
  history: any;
  locale: string;
  bookingID: string;
  quoteID: string;
  securityToken: string | null;
  hasClaimGuidelines?: boolean;
}

export const navigateToClaimQuestionPage = ({
  decisionPointId,
  history,
  locale,
  bookingID,
  quoteID,
  securityToken,
  hasClaimGuidelines = false,
}: INavigateToClaimQuestionsPageArgs): void => {
  const searchParams = new URLSearchParams({ bookingID, quoteID });
  if (securityToken) {
    searchParams.append('security_token', securityToken);
  } else if (hasClaimGuidelines) {
    searchParams.append('claimGuidelines', 'true');
  }
  history.push(`/${locale}/account/claims/fnol/questions/${decisionPointId}?${searchParams}`);
};

export const redirectIfDifferentLocale = () => {
  const currentLocale = sessionStorage.getItem(CURRENT_LOCALE);
  const [, lang, pathRemainder] =
    window.location.href.substring(window.location.origin.length).match(/\/?(.+?)(\/.+)$/) || [];
  if (currentLocale && currentLocale !== lang) {
    const correctUrl = `/${currentLocale}${pathRemainder || ''}`;
    return <Redirect to={correctUrl} />;
  }
  return null;
};
